<template>
  <div class="approvalsList">
    <div class="headerBox">
      <div class="ser">{{ $t('public.recordr') }}</div>
      <!-- <div class="ser">
        <a-button type="primary">
         {{ 通过}}
        </a-button>
        <a-button type="danger">
          拒绝
        </a-button>
        <a-button type="primary">
          全部通过
        </a-button>
      </div> -->
    </div>
    <div class="contentBox">
      <a-table
        :data-source="approvalList"
        :rowKey="approvalList => approvalList.id"
        :scroll="{ x: 1500 }"
        :pagination="{
          total: total,
          pageSize: pageSize,
          current: current,
          showTotal: total =>
            $t('public.page', { total: total, pageSize: pageSize }),
          onChange: currentChange
        }"
      >
        <a-table-column
          :width="150"
          fixed="left"
          :title="$t('public.subject')"
          dataIndex="courseName"
        >
        </a-table-column>
        <a-table-column
          fixed="left"
          :width="150"
          :title="$t('public.student') + $t('public.name')"
          dataIndex="studentName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.student') + $t('report.grade')"
          dataIndex="status"
        >
          <template slot-scope="status">
            <p>{{ status == 9 ? 'Pre10' : status }}</p>
          </template>
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('report.academicYear')"
          dataIndex="academic"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.teacher') + $t('public.name')"
          dataIndex="teacherName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.submitter')"
          dataIndex="submitterName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.approver')"
          dataIndex="approverName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.scoreType')"
          dataIndex="type"
        >
          <template slot-scope="type">
            <p>
              {{
                type == 1
                  ? 'Regular Grade'
                  : type == 2
                  ? 'Semester Exam'
                  : 'Quiz'
              }}
            </p>
          </template>
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.details')"
          dataIndex="details"
        >
        </a-table-column>
        <!-- //323 -->
        <a-table-column
          :width="150"
          :title="$t('public.submissionTime')"
          dataIndex="createTime"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          fixed="right"
          :title="$t('public.oldScore')"
          dataIndex="oldScore"
        >
        </a-table-column>
        <a-table-column
          fixed="right"
          :width="150"
          :title="$t('public.newScore')"
          dataIndex="newScore"
        >
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedRowKeys: [],
      pageSize: 10,
      total: 0,
      current: 1,
      approvalList: []
    }
  },
  methods: {
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    currentChange(pageNumber) {
      let data = {
        pageSize: this.pageSize,
        pageNO: pageNumber
      }
      this.current = pageNumber
      this.approvalData(data)
    },
    approvalData(data) {
      this.$http(this.$api.SELECTPAGERECORD, data).then(r => {
        this.total = r.data.total
        this.approvalList = r.data.rows
      })
    }
  },
  created() {
    let data = {
      pageSize: this.pageSize,
      pageNO: this.current
    }
    this.approvalData(data)
  }
}
</script>

<style lang="less" scoped>
.approvalsList {
  width: 100%;
  height: calc(100% - 150px);

  .APPROVED {
    color: #6aaae4;
  }

  .REJECTED {
    color: red;
  }

  .headerBox {
    width: 100%;
    height: 60px;
    padding: 0 20px;
    box-sizing: border-box;
    background-color: #fff;
    .ser {
      width: 50%;
      height: 100%;
      line-height: 60px;
      float: left;
      font-size: 15px;
    }

    .ser:last-child {
      /deep/ .ant-btn {
        float: right;
        margin-top: 15px;
        margin-left: 10px;
      }
    }
  }

  .contentBox {
    width: 100%;
    height: 100%;
  }
}
</style>
